export default __webpack_public_path__ + "static/media/no-content.6c3d22c2.png";